import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import {
  Box,
  CircularProgress,
  Drawer,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import { formatDate } from "../../../../common/formatDate";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import Checkbox from "@material-ui/core/Checkbox";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import CommentIcon from "@material-ui/icons/Comment";
const useStyles = makeStyles({
  titleBar: {
    minHeight: 56,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    rowGap: 8,
    columnGap: 8,
    padding: "8px 5px",
    background: "#fff",
    borderBottom: "1px solid #e5e7eb",
    boxSizing: "border-box",
    width: "100%",
    maxWidth: "100%",
    overflowX: "hidden",
  },

  titleLeft: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    rowGap: 8,
    minWidth: 0,
  },

  backBtn: {
    display: "flex",
    alignItems: "center",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#4b5563",
    fontSize: 12,
    "&:hover": {
      color: "#1976d2",
    },
  },

  divider: {
    width: 1,
    height: 24,
    background: "#ddd",
    margin: "0 16px",
  },

  documentTitle: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },

  docId: {
    color: "#6b7280",
    fontSize: 14,
  },

  title: {
    fontSize: 14,
    fontWeight: 500,
    color: "#111827",
  },

  titleRight: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 16,
    rowGap: 8,
  },

  status: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    borderRadius: 20,
    background: "#eef4ff",
    color: "#2563eb",
    fontSize: 10,
    fontWeight: 600,
  },

  statusDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#2563eb",
  },

  version: {
    color: "#6b7280",
    fontSize: 14,
  },

  submitBtn: {
    height: 36,
    minWidth: 90,
    border: "none",
    borderRadius: 8,
    padding: "8px 16px",
    cursor: "pointer",
    background: "#126B42",
    color: "#fff",
    fontSize: 14,
    fontWeight: 500,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      background: "#0d5c38",
    },
  },
  feedbackBtn: {
    height: 36,
    minWidth: 90,
    padding: "0 10px",
    border: "none",
    borderRadius: 6,
    backgroundColor: "#E8EFFA",
    color: "#1268A9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 5,
    fontSize: 12,
    fontWeight: 500,
    cursor: "pointer",
    fontFamily: "inherit",
    boxSizing: "border-box",

    "&:hover": {
      backgroundColor: "#C3DAF2",
      boxShadow: "inset 0 0 0 1px #8FBFEA", // Draws the border purely inside without altering element dimensions
    },
  },
  drawerPaper: {
    width: 350,
    padding: 20,
  },

  drawerHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },

  versionCard: {
    background: "#edf7f4",
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
    cursor: "pointer",
  },

  badge: {
    display: "inline-block",
    marginTop: 8,
    padding: "3px 8px",
    borderRadius: 4,
    background: "#eef4ff",
    color: "#2563eb",
    fontSize: 9,
  },
  userList: {
    display: "flex",
    alignItems: "center",
    marginLeft: 8,
  },

  avatar: {
    width: 25,
    height: 25,
    fontSize: 8,
    fontWeight: 600,
    border: "2px solid #fff",
    marginLeft: -8,
  },

  // onlineDot: {
  //   backgroundColor: "#22c55e",
  //   color: "#22c55e",
  //   boxShadow: "0 0 0 2px white",
  // },

  // onlineText: {
  //   marginLeft: 10,
  //   color: "#6b7280",
  //   fontSize: 12,
  // },
  emptyState: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "calc(100vh - 80px)",
    color: "#6b7280",
    fontSize: 14,
  },
  drawerContent: {
    flex: 1,
    overflowY: "auto",
    padding: 16,

    "&::-webkit-scrollbar": {
      width: 6,
    },

    "&::-webkit-scrollbar-track": {
      background: "#F3F4F6",
    },

    "&::-webkit-scrollbar-thumb": {
      background: "#C7CDD4",
      borderRadius: 20,
    },
  },
  versionItem: {
    padding: "16px 0",
    borderBottom: "1px solid #F1F3F5",

    "&:last-child": {
      borderBottom: "none",
    },
  },

  versionTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: "#111827",
    marginBottom: 4,
  },

  subText: {
    fontSize: 13,
    color: "#6B7280",
    marginBottom: 4,
  },

  date: {
    fontSize: 13,
    color: "#6B7280",
    marginBottom: 10,
  },
  drawerFooter: {
    padding: 16,
    borderTop: "1px solid #E5E7EB",
    background: "#fff",
  },
});

interface ReportImage {
  blob_url: string;
  image_name: string;
}

interface ReportImageGroup {
  [category: string]: ReportImage[];
}

// Updated interface to include project_id and bom_workorder
export interface SelectedImage {
  stage?: string;
  serial_number?: string;
  project_id?: number | string;
  bom_workorder?: string;
  images: any[];
  type: "blob" | "base64";
}

interface TipTapTitleBarProps {
  title?: string;
  version?: string;
  status?: string;
  versionHistory?: any[];
  onBack?: () => void;
  onSubmit?: () => void;
  isMovingWriterToReviewer?: boolean;
  workOrder?: string;
  ProjectId?: string;
  reportImages?: any[];
  selectedImages?: SelectedImage[];
  onImageSelect?: (image: SelectedImage) => void;
  // Updated Type Signature
  onInsertImages?: (
    position?: any,
    targetEditor?: any,
    imageUrl?: string,
  ) => void;
  isLoading?: boolean;
  role: string;
  feedbackCount?: number;
  onChecklist?: () => void;
  onComments?: () => void;
}

export const TipTapTitleBar = ({
  title = "",
  version = "",
  status = "Writing",
  versionHistory = [],
  onBack,
  workOrder,
  ProjectId,
  isMovingWriterToReviewer,
  onSubmit,
  reportImages = [],
  selectedImages = [],
  onImageSelect = () => { },
  onInsertImages = () => { },
  isLoading = false,
  role,
  feedbackCount = 0,
  onChecklist,
  onComments,
}: TipTapTitleBarProps) => {
  const classes = useStyles();

  // const onlineUsers = [
  //   {
  //     id: 1,
  //     initials: "CG",
  //     color: "#0f766e",
  //   },
  //   {
  //     id: 2,
  //     initials: "R",
  //     color: "#6d28d9",
  //   },
  // ];

  const [historyOpen, setHistoryOpen] = useState(false);
  const [IntakeImagesOpen, setIntakeImagesOpen] = useState(false);

  const [targetEditor, setTargetEditor] = useState<any>(null); // <--- ITHA PUTHUSA ADD PANNUNGA

  const [imageSource, setImageSource] = useState<"library" | "lsdb">("library");

  const [elImages, setElImages] = useState<any[]>([]);
  const [insertPosition, setInsertPosition] = useState<any>(null);
  const [feImageTablePosition, setFeImageTablePosition] = useState<number | undefined>();

  // console.log("Current role in TipTapTitleBar:", role);

  const normalizeRole = role?.trim().toLowerCase();
  const normalizeStatus = status?.trim().toLowerCase();

  const isWriter = normalizeRole === "writer";
  const isReviewer = normalizeRole === "reviewer";
  const isVerifier = normalizeRole === "verifier";
  const isApprover = normalizeRole === "approver";

  const canSubmitForReview =
    isWriter && ["writing", "notstarted"].includes(normalizeStatus);

  const showWriterFeedback =
    isWriter &&
    feedbackCount > 0 &&
    ["corr_rev", "corr_ver", "corr_app"].includes(status);

  const getSubmitButtonText = (role: string) => {
    switch (role) {
      case "writer":
        return "Submit for review";

      case "reviewer":
        return "Submit for verification";

      case "verifier":
        return "Submit for approval";

      case "approver":
        return "Approve report";

      default:
        return "Submit";
    }
  };

  useEffect(() => {
    const handleOpenImageDrawer = (event: any) => {
      // targetEditor-a event.detail la irunthu edukkum
      const { is_image, images, insertPosition, targetEditor, feImageTablePosition } =
        event.detail || {};

      if (!is_image) return;
      setImageSource("lsdb");
      setElImages(images || []);
      setFeImageTablePosition(feImageTablePosition);

      setInsertPosition(insertPosition || null);
      setTargetEditor(targetEditor || null); // <--- ITHA PUTHUSA ADD PANNUNGA

      setIntakeImagesOpen(true);
    };

    window.addEventListener("open-image-drawer", handleOpenImageDrawer);
    return () =>
      window.removeEventListener("open-image-drawer", handleOpenImageDrawer);
  }, []);

  return (
    <>
      <div className={classes.titleBar}>
        <div className={classes.titleLeft}>
          <button className={classes.backBtn} onClick={onBack}>
            <KeyboardBackspaceIcon style={{ fontSize: 15, marginRight: 4 }} />
            <span>Back to agenda</span>
          </button>

          <div className={classes.divider} />

          <div className={classes.documentTitle}>
            <span className={classes.title}>{title}</span>
          </div>
        </div>

        <div className={classes.titleRight}>
          {/* <div className={classes.status}>
            <span className={classes.statusDot} />
            {status}
          </div> */}

          <span className={classes.version}>{version}</span>

          {isVerifier &&
            
            ["verify"].includes(status) && (
              <button
                className={classes.feedbackBtn}
                onClick={status === "corr_rev" ? onChecklist : onComments}
              >
                {status === "corr_rev" ? (
                  <img src="/Comments.svg" alt="Comments & Notes" style={{ width: 16, height: 16, display: "block" }} />
                ) : (
                  <CommentIcon style={{ fontSize: 20 }} />
                )}

                <span>
                  {status === "corr_rev" ? "Comments" : "Comments"}
                </span>
              </button>
            )}

            {isApprover &&
            
            ["approval"].includes(status) && (
              <button
                className={classes.feedbackBtn}
                onClick={status === "corr_rev" ? onChecklist : onComments}
              >
                {status === "corr_rev" ? (
                  <img src="/Comments.svg" alt="Comments & Notes" style={{ width: 16, height: 16, display: "block" }} />
                ) : (
                  <CommentIcon style={{ fontSize: 20 }} />
                )}

                <span>
                  {status === "corr_rev" ? "Comments" : "Comments"}
                </span>
              </button>
            )}

            {isWriter &&
            
            ["corr_rev", "corr_ver", "corr_app"].includes(status) && (
              <button
                className={classes.feedbackBtn}
                onClick={status === "corr_rev" ? onChecklist : onComments}
              >
                {status === "corr_rev" ? (
                  <img src="/Comments.svg" alt="Comments & Notes" style={{ width: 16, height: 16, display: "block" }} />
                ) : (
                  <CommentIcon style={{ fontSize: 20 }} />
                )}

                <span>
                  {status === "corr_rev" ? "Comments" : "Comments"}
                </span>
              </button>
            )}

          {/* {isReviewer && (
            <button className={classes.feedbackBtn} onClick={onChecklist}>
              
              <img src="/Checklist.svg" alt="" style={{ width: 18, height: 18, display: "block" }} />
              <span>Checklist</span>
            </button>
          )} */}

          {canSubmitForReview && (
            <button
              className={classes.submitBtn}
              onClick={onSubmit}
              disabled={isMovingWriterToReviewer}
            >
              {isMovingWriterToReviewer ? (
                <>
                  <CircularProgress size={16} color="inherit" />
                  Submitting...
                </>
              ) : (
                "Submit for review"
              )}
            </button>
          )}

          {/* <div className={classes.userList}>
            {onlineUsers.map((user) => (
              <Badge
                key={user.id}
                overlap="circle"
                variant="dot"
                classes={{ dot: classes.onlineDot }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
              >
                <Avatar
                  className={classes.avatar}
                  style={{ background: user.color }}
                >
                  {user.initials}
                </Avatar>
              </Badge>
            ))}

            <span className={classes.onlineText}>
              {onlineUsers.length} online
            </span>
          </div> */}

          <IconButton onClick={() => setHistoryOpen(true)}>
            <img src="/History.svg" alt="Version History" style={{ width: 16, height: 16, display: "block" }} />
          </IconButton>
        </div>
      </div>
      <Drawer
        anchor="right"
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <h3 style={{ margin: 0 }}>Version history</h3>

          <IconButton onClick={() => setHistoryOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>

        <div className={classes.drawerContent}>
          {versionHistory && versionHistory.length > 0 ? (
            versionHistory.map((item, index) => (
              <div
                key={item.version}
                className={
                  index === 0 ? classes.versionCard : classes.versionItem
                }
              >
                <div className={classes.versionTitle}>
                  Version {item.version.replace("v", "")}
                  {index === 0 && " — Current"}
                </div>

                <div className={classes.subText}>
                  {item.status?.toLowerCase() === "saved as version"
                    ? "Manual Save"
                    : item.status}{" "}
                  · {item.saved_by}
                </div>

                <div className={classes.date}>
                  {formatDate(item.created_at)}
                </div>

                <span className={classes.badge}>
                  {item.status?.toLowerCase() === "saved as version"
                    ? "Writing"
                    : item.status}
                </span>
              </div>
            ))
          ) : (
            <div className={classes.emptyState}>No version history found.</div>
          )}
        </div>
      </Drawer>
      <Drawer
        anchor="right"
        open={IntakeImagesOpen}
        onClose={() => setIntakeImagesOpen(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <h3 style={{ margin: 0 }}>Insert Images</h3>

          <IconButton onClick={() => setIntakeImagesOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={classes.drawerContent}>
          {imageSource === "library" ? (
            <>
              {reportImages && reportImages.length > 0 ? (
                reportImages.map((group, groupIndex) =>
                  Object.entries(group).map(([category, images]) => (
                    <div key={`${category}-${groupIndex}`}>
                      <h4>{category}</h4>

                      {(images as any[]).map((image) => (
                        <div
                          key={image.blob_url}
                          style={{
                            border: selectedImages.some((item) =>
                              item.images.includes(image.blob_url),
                            )
                              ? "2px solid #1976d2"
                              : "1px solid #ddd",
                            borderRadius: 8,
                            marginBottom: 16,
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "8px 12px",
                            }}
                          >
                            <span>{image.image_name}</span>

                            <Checkbox
                              checked={selectedImages.some((item) =>
                                item.images.includes(image.blob_url),
                              )}
                              onChange={() =>
                                onImageSelect({
                                  images: [image.blob_url],
                                  type: "blob",
                                })
                              }
                            />
                          </div>

                          <img
                            src={image.blob_url}
                            alt={image.image_name}
                            style={{
                              width: "100%",
                              maxHeight: 220,
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )),
                )
              ) : (
                <div className={classes.emptyState}>No images found.</div>
              )}
            </>
          ) : (
            <>
              {elImages && elImages.length > 0 ? (
                elImages.map((item: any, index: number) => {
                  // Format Detection
                  const isBlobFormat =
                    Array.isArray(item.image_path) &&
                    item.image_path.length > 0 &&
                    typeof item.image_path[0] === "object";

                  const isBase64StringPathFormat =
                    Array.isArray(item.image_path) &&
                    item.image_path.length > 0 &&
                    typeof item.image_path[0] === "string";

                  // --- NEW: Detect your specific img_data format ---
                  const isNewImgDataFormat =
                    item.image !== undefined && typeof item.image === "string";

                  // --- NEW: Detect the "grouped visuals" wrapper format
                  // returned by endpoints like .../bds_visuals/ — each item
                  // bundles multiple named sections as sibling keys (e.g.
                  // "Pre BDS visuals" / "Post BDS visuals"), each holding
                  // { serial_number, image: [{ image: "<base64>" }, ...] }.
                  const groupKeys = Object.keys(item || {}).filter((key) => {
                    const group = item[key];
                    return (
                      group &&
                      typeof group === "object" &&
                      !Array.isArray(group) &&
                      (Array.isArray(group.image) || Array.isArray(group.images))
                    );
                  });
                  const isGroupedVisualsFormat = groupKeys.length > 0;

                  // Header label identifier
                  const cardTitle =
                    item.image_name ||
                    item.serial_number ||
                    item.bom_workorder ||
                    (item.parameter_type ? ` ${item.parameter_type}` : null) ||
                    (isGroupedVisualsFormat
                      ? item[groupKeys[0]]?.serial_number
                      : null) ||
                    (item.project_id
                      ? `Project ID: ${item.project_id}`
                      : `Item ${index + 1}`);

                  return (
                    <div
                      key={`${item.serial_number || item.project_id || item.Report_result_id || index}-${index}`}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: 8,
                        padding: 12,
                        marginBottom: 16,
                      }}
                    >
                      {/* Card Header Title */}
                      <div style={{ marginBottom: 8 }}>
                        <span style={{ fontWeight: 600 }}>{cardTitle}</span>
                      </div>

                      {/* --- NEW FORMAT: Grouped visuals wrapper (e.g. "Pre BDS visuals" / "Post BDS visuals") --- */}
                      {isGroupedVisualsFormat ? (
                        <>
                          {groupKeys.map((groupKey) => {
                            const group = item[groupKey];
                            const groupImages: any[] = Array.isArray(group?.images)
                              ? group.images
                              : group?.image || [];
                            const serialNumber = group?.serial_number || item.serial_number;

                            return (
                              <div key={groupKey} style={{ marginTop: 10 }}>
                                <Typography
                                  variant="subtitle2"
                                  style={{ fontWeight: 600, marginBottom: 6 }}
                                >
                                  {groupKey}
                                  {group?.procedure_name
                                    ? ` — ${group.procedure_name}`
                                    : ""}
                                  {group?.serial_number
                                    ? ` — ${group.serial_number}`
                                    : ""}
                                </Typography>

                                {groupImages.length > 0 ? (
                                  groupImages.map(
                                    (imgObj: any, imgIndex: number) => {
                                      const base64Str =
                                        typeof imgObj === "string"
                                          ? imgObj
                                          : imgObj?.image;
                                      if (!base64Str) return null;

                                      const isChecked = selectedImages.some(
                                        (selected: any) =>
                                          (feImageTablePosition === undefined ||
                                            (selected.stage === groupKey && selected.serial_number === serialNumber)) &&
                                          selected.images?.includes(
                                            base64Str,
                                          ),
                                      );

                                      return (
                                        <div
                                          key={`${groupKey}-${imgIndex}`}
                                          style={{
                                            border: isChecked
                                              ? "2px solid #1976d2"
                                              : "1px solid #eee",
                                            borderRadius: 6,
                                            padding: 8,
                                            marginTop: 10,
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              style={{ fontWeight: 500 }}
                                            >
                                              {imgObj?.image_name ||
                                                `Image ${imgIndex + 1}`}
                                            </Typography>

                                            <Checkbox
                                              color="primary"
                                              checked={isChecked}
                                              onChange={() =>
                                                onImageSelect({
                                                  serial_number:
                                                    serialNumber,
                                                  images: [base64Str],
                                                  type: "base64",
                                                  ...(feImageTablePosition === undefined ? {} : { stage: groupKey }),
                                                })
                                              }
                                            />
                                          </div>

                                          <img
                                            src={
                                              base64Str.startsWith(
                                                "data:image",
                                              ) || base64Str.startsWith("http")
                                                ? base64Str
                                                : `data:image/jpeg;base64,${base64Str}`
                                            }
                                            alt={
                                              imgObj?.image_name || groupKey
                                            }
                                            style={{
                                              width: "100%",
                                              maxHeight: 220,
                                              objectFit: "contain",
                                              marginTop: 4,
                                            }}
                                          />
                                        </div>
                                      );
                                    },
                                  )
                                ) : (
                                  <Typography
                                    color="textSecondary"
                                    style={{ marginTop: 4 }}
                                  >
                                    No image found.
                                  </Typography>
                                )}
                              </div>
                            );
                          })}
                        </>
                      ) : /* --- NEW FORMAT: Direct Image String with Image Name --- */
                      isNewImgDataFormat ? (
                        <div
                          style={{
                            border: "1px solid #eee",
                            borderRadius: 6,
                            padding: 8,
                            marginTop: 10,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="body2"
                              style={{ fontWeight: 500 }}
                            >
                              {item.image_name || `Image ${index + 1}`}
                            </Typography>

                            <Checkbox
                              color="primary"
                              checked={selectedImages.some((selected: any) =>
                                selected.images?.includes(item.image),
                              )}
                              onChange={() =>
                                onImageSelect({
                                  serial_number: item.image_name,
                                  images: [item.image],
                                  type: "base64",
                                })
                              }
                            />
                          </div>

                          <img
                            src={
                              item.image.startsWith("data:image") ||
                                item.image.startsWith("http")
                                ? item.image
                                : `data:image/jpeg;base64,${item.image}`
                            }
                            alt={item.image_name || "Inspection Image"}
                            style={{
                              width: "100%",
                              maxHeight: 220,
                              objectFit: "contain",
                              marginTop: 4,
                            }}
                          />
                        </div>
                      ) : /* --- FORMAT 1: Blob URL Objects Array --- */
                        isBlobFormat ? (
                          item.image_path.length > 0 ? (
                            <>
                              {/* ================= INTAKE IMAGES ================= */}
                              {item.image_path.some(
                                (group: any) => group.ModuleIntake !== undefined,
                              ) && (
                                  <>
                                    <Typography
                                      variant="h6"
                                      style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                        marginTop: 12,
                                        marginBottom: 12,
                                      }}
                                    >
                                      Module Intake
                                    </Typography>

                                    {(() => {
                                      const intakeImages = item.image_path
                                        .filter(
                                          (group: any) =>
                                            group.ModuleIntake !== undefined,
                                        )
                                        .flatMap(
                                          (group: any) => group.ModuleIntake || [],
                                        );

                                      return intakeImages.length > 0 ? (
                                        intakeImages.map(
                                          (imgObj: any, imgIndex: number) => {
                                            const isChecked = selectedImages.some(
                                              (selected: any) =>
                                                selected.images?.includes(
                                                  imgObj.blob_url,
                                                ),
                                            );

                                            return (
                                              <div
                                                key={`intake-${imgObj.blob_url}-${imgIndex}`}
                                                style={{
                                                  border: isChecked
                                                    ? "2px solid #1976d2"
                                                    : "1px solid #eee",
                                                  borderRadius: 6,
                                                  padding: 8,
                                                  marginTop: 10,
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Typography
                                                    variant="body2"
                                                    style={{ fontWeight: 500 }}
                                                  >
                                                    {imgObj.image_name ||
                                                      `Image ${imgIndex + 1}`}
                                                  </Typography>

                                                  <Checkbox
                                                    color="primary"
                                                    checked={isChecked}
                                                    onChange={() =>
                                                      onImageSelect({
                                                        project_id: item.project_id,
                                                        bom_workorder:
                                                          item.bom_workorder,
                                                        images: [imgObj.blob_url],
                                                        type: "blob",
                                                      })
                                                    }
                                                  />
                                                </div>

                                                <img
                                                  src={imgObj.blob_url}
                                                  alt={
                                                    imgObj.image_name ||
                                                    "Intake Image"
                                                  }
                                                  style={{
                                                    width: "100%",
                                                    maxHeight: 220,
                                                    objectFit: "contain",
                                                    marginTop: 4,
                                                  }}
                                                />
                                              </div>
                                            );
                                          },
                                        )
                                      ) : (
                                        <Typography
                                          color="textSecondary"
                                          style={{
                                            marginTop: 10,
                                            marginBottom: 10,
                                          }}
                                        >
                                          No images found.
                                        </Typography>
                                      );
                                    })()}
                                  </>
                                )}

                              {/* ================= CRATE INTAKE IMAGES ================= */}
                              {item.image_path.some(
                                (group: any) => group.CrateIntake !== undefined,
                              ) && (
                                  <>
                                    <Typography
                                      variant="h6"
                                      style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                        marginTop: 24,
                                        marginBottom: 12,
                                      }}
                                    >
                                      Crate Intake
                                    </Typography>

                                    {(() => {
                                      const crateImages = item.image_path
                                        .filter(
                                          (group: any) =>
                                            group.CrateIntake !== undefined,
                                        )
                                        .flatMap(
                                          (group: any) => group.CrateIntake || [],
                                        );

                                      if (crateImages.length === 0) {
                                        return (
                                          <Typography
                                            color="textSecondary"
                                            style={{
                                              marginTop: 10,
                                              marginBottom: 10,
                                            }}
                                          >
                                            No images found.
                                          </Typography>
                                        );
                                      }

                                      return crateImages.map(
                                        (imgObj: any, imgIndex: number) => {
                                          const isChecked = selectedImages.some(
                                            (selected: any) =>
                                              selected.images?.includes(
                                                imgObj.blob_url,
                                              ),
                                          );

                                          return (
                                            <div
                                              key={`crate-${imgObj.blob_url}-${imgIndex}`}
                                              style={{
                                                border: isChecked
                                                  ? "2px solid #1976d2"
                                                  : "1px solid #eee",
                                                borderRadius: 6,
                                                padding: 8,
                                                marginTop: 10,
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "space-between",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <Typography
                                                  variant="body2"
                                                  style={{ fontWeight: 500 }}
                                                >
                                                  {imgObj.image_name ||
                                                    `Image ${imgIndex + 1}`}
                                                </Typography>

                                                <Checkbox
                                                  color="primary"
                                                  checked={isChecked}
                                                  onChange={() =>
                                                    onImageSelect({
                                                      project_id: item.project_id,
                                                      bom_workorder:
                                                        item.bom_workorder,
                                                      images: [imgObj.blob_url],
                                                      type: "blob",
                                                    })
                                                  }
                                                />
                                              </div>

                                              <img
                                                src={imgObj.blob_url}
                                                alt={
                                                  imgObj.image_name ||
                                                  "Crate Intake Image"
                                                }
                                                style={{
                                                  width: "100%",
                                                  maxHeight: 220,
                                                  objectFit: "contain",
                                                  marginTop: 4,
                                                }}
                                              />
                                            </div>
                                          );
                                        },
                                      );
                                    })()}
                                  </>
                                )}
                            </>
                          ) : (
                            <Typography
                              color="textSecondary"
                              style={{ marginTop: 10 }}
                            >
                              No image found.
                            </Typography>
                          )
                        ) : /* --- FORMAT 2: Direct Base64 Strings inside image_path --- */
                          isBase64StringPathFormat ? (
                            item.image_path.map(
                              (base64Str: string, imgIndex: number) => {
                                const isChecked = selectedImages.some(
                                  (selected: any) =>
                                    selected.images?.includes(base64Str),
                                );

                                return (
                                  <div
                                    key={imgIndex}
                                    style={{
                                      border: "1px solid #eee",
                                      borderRadius: 6,
                                      padding: 8,
                                      marginTop: 10,
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        style={{ fontWeight: 500 }}
                                      >
                                        {item.parameter_type
                                          ? `${item.parameter_type.toUpperCase()} - Image ${imgIndex + 1}`
                                          : `Image ${imgIndex + 1}`}
                                      </Typography>

                                      <Checkbox
                                        color="primary"
                                        checked={isChecked}
                                        onChange={() =>
                                          onImageSelect({
                                            serial_number: String(
                                              item.Report_result_id,
                                            ),
                                            images: [base64Str],
                                            type: "base64",
                                          })
                                        }
                                      />
                                    </div>

                                    <img
                                      src={
                                        base64Str.startsWith("data:image")
                                          ? base64Str
                                          : `data:image/jpeg;base64,${base64Str}`
                                      }
                                      alt={item.parameter_type || "EL Base64 Image"}
                                      style={{
                                        width: "100%",
                                        maxHeight: 220,
                                        objectFit: "contain",
                                        marginTop: 4,
                                      }}
                                    />
                                  </div>
                                );
                              },
                            )
                          ) : /* --- FORMAT 3: Legacy item.image base64 array --- */
                            item.image?.some && item.image.some((img: any) => img) ? (
                              item.image.map((img: any, imgIndex: number) =>
                                img ? (
                                  <div
                                    key={imgIndex}
                                    style={{
                                      border: "1px solid #eee",
                                      borderRadius: 6,
                                      padding: 8,
                                      marginTop: 10,
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Checkbox
                                        color="primary"
                                        checked={selectedImages.some(
                                          (selected: any) =>
                                            selected.serial_number ===
                                            item.serial_number &&
                                            selected.images?.includes(img),
                                        )}
                                        onChange={() =>
                                          onImageSelect({
                                            serial_number: item.serial_number,
                                            images: [img],
                                            type: "base64",
                                          })
                                        }
                                      />
                                    </div>
                                    <img
                                      src={
                                        img.startsWith("data:image")
                                          ? img
                                          : `data:image/jpeg;base64,${img}`
                                      }
                                      alt={item.serial_number || "EL Image"}
                                      style={{
                                        width: "100%",
                                        maxHeight: 220,
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>
                                ) : null,
                              )
                            ) : (
                              <Typography
                                color="textSecondary"
                                style={{ marginTop: 10 }}
                              >
                                No image found.
                              </Typography>
                            )}
                    </div>
                  );
                })
              ) : (
                <div className={classes.emptyState}>No images found.</div>
              )}
            </>
          )}
        </div>

        {(reportImages?.length > 0 || elImages?.length > 0) && (
          <div className={classes.drawerFooter}>
            <button
              className={classes.submitBtn}
              style={{ width: "100%", padding: "10px 16px" }}
              disabled={selectedImages.length === 0}
              onClick={() => {
                // FIXED: Removed the undefined `selectedImage` variable.
                // The main component already knows what is selected via state.
                onInsertImages(feImageTablePosition === undefined ? insertPosition : {
                  type: "fe_stage_images",
                  tablePosition: feImageTablePosition,
                  records: elImages,
                }, targetEditor);
                setIntakeImagesOpen(false);
              }}
            >
              Insert Images
              {selectedImages.length > 0 && ` (${selectedImages.length})`}
            </button>
          </div>
        )}
      </Drawer>
    </>
  );
};
